import exif from 'exif-js'
import { storage, TaskState } from '@/firebase/config'

export default {
  data: () => ({
    file: null,
    previewFile: null,
    uploadTask: null,
    uploading: false,
    uploadName: '',
    uploadSize: 0,
    progress: 0,
    previewWidth: 0,
    previewHeight: 0
  }),
  computed: {
    fileinputID() {
      return 'fileInput'
    },
    filepath() {
      return ''
    },
    uploadOnChange() {
      return false;
    }
  },
  methods: {
    uploadFinished() { },

    didTapFileInput() {
      let fileInput = document.getElementById(this.fileinputID)
      fileInput.click()
    },

    didTapCancel() {
      if (this.uploadTask) {
        this.uploadTask.cancel()
      }
      this.uploading = false
    },

    readFile(file) {
      return new Promise(resolve => {
        let reader = new FileReader()
        reader.onload = e => resolve(e.target.result)
        reader.readAsDataURL(file)
      })
    },

    rotate(img) {
      return new Promise(resolve => {
        const canvas = document.createElement('canvas')
        let vm = this;
        exif.getData(img, function () {
          let orientation = exif.getAllTags(this).Orientation

          if ([5, 6, 7, 8].indexOf(orientation) > -1) {
            canvas.width = img.height
            canvas.height = img.width
          } else {
            canvas.width = img.width
            canvas.height = img.height
          }

          let ctx = canvas.getContext('2d')

          switch (orientation) {
            case 2:
              ctx.transform(-1, 0, 0, 1, img.width, 0)
              break
            case 3:
              ctx.transform(-1, 0, 0, -1, img.width, img.height)
              break
            case 4:
              ctx.transform(1, 0, 0, -1, 0, img.height)
              break
            case 5:
              ctx.transform(0, 1, 1, 0, 0, 0)
              break
            case 6:
              ctx.transform(0, 1, -1, 0, img.height, 0)
              break
            case 7:
              ctx.transform(0, -1, -1, 0, img.height, img.width)
              break
            case 8:
              ctx.transform(0, -1, 1, 0, 0, img.width)
              break
            default:
              ctx.transform(1, 0, 0, 1, 0, 0)
          }
          ctx.drawImage(img, 0, 0, img.width, img.height)
          vm.previewWidth = canvas.width;
          vm.previewHeight = canvas.height;
          resolve(canvas.toDataURL('image/png', 0.9))
        })
      })
    },

    didChangeFile(e) {
      let files = e.target.files || e.dataTransfer.files
      if (!files.length) return
      this.file = files[0]
      this.setPreviewFile(this.file);
    },

    setPreviewFile(file) {
      let fileReader = new FileReader();

      fileReader.onload = () => {
        this.previewFile = fileReader.result;
        if (this.uploadOnChange) {
          this.setupUpload();
        }
      }
      fileReader.readAsDataURL(file);
    },

    setupUpload() {
      let fileType = this.file.type;
      let validImageTypes = ['image/gif', 'image/jpeg', 'image/png'];
      if (validImageTypes.includes(fileType)) {
        let img = new Image();
        img.onload = () => {
          this.rotate(img).then(data => {
            this.upload(data);
          });
        }
        img.src = this.previewFile;
      } else {
        this.upload(this.previewFile);
      }
    },

    upload(data) {
      this.uploadName = this.file.name
      this.uploadSize = (this.file.size / 1024 / 1024).toFixed(2) + 'MB'
      let storageRef = storage.ref()
      this.uploadTask = storageRef
        .child(this.filepath)
        .putString(data, 'data_url')
      this.uploadTask.on(
        'state_changed',
        (snapshot) => {
          this.uploading = true
          this.progress = parseInt((
            (snapshot.bytesTransferred / snapshot.totalBytes) *
            100
          ).toFixed(0)) || 0
          switch (snapshot.state) {
            case TaskState.PAUSED: // or 'paused'
              break
            case TaskState.RUNNING: // or 'running'
              break
          }
        },
        //onError
        (error) => {
          if (error) {
            this.didTapCancel();
          }
        },
        //onComplete
        () => {
          this.uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) => {
            this.uploadFinished(downloadURL);
          })
        }
      )
    }
  }
}